// https://fusion-api.dev.mos.coke.com/v1/projects

import { briefApi } from 'api'
import { ApiQueryCommonParams, ApiResponse } from 'types/common/utils'
import { Project } from 'types/Project'

export interface ProjectsQueryParams extends ApiQueryCommonParams {
  uhubStatus?: string
  uhubProjectStatus?: string
  status?: string
  syncStatus?: string
  operatingUnit?: string
  createdAtStart?: string
  createdAtEnd?: string
  targetInMarketDateStart?: string
  targetInMarketDateEnd?: string
  briefType?: string
  workfrontProjectId?: string
}

export const fetchProjects = ({
  page,
  limit,
  sortBy,
  sortDirection,
  search,
  uhubProjectStatus,
  createdAtEnd,
  createdAtStart,
  operatingUnit,
  status,
  syncStatus,
  targetInMarketDateEnd,
  targetInMarketDateStart,
  uhubStatus,
  briefType,
  workfrontProjectId,
}: ProjectsQueryParams) =>
  briefApi.get<ApiResponse<Project>>('/projects', {
    params: {
      page,
      limit,
      sortField: !!sortBy ? sortBy : undefined,
      sortDirection: !!sortBy && !!sortDirection ? [sortDirection] : undefined,
      search: search || undefined,
      uhubProjectStatus: uhubProjectStatus || undefined,
      createdAtEnd: createdAtEnd ? createdAtEnd : undefined,
      createdAtStart: createdAtStart || undefined,
      operatingUnit: operatingUnit || undefined,
      status: status || undefined,
      syncStatus: syncStatus || undefined,
      targetInMarketDateEnd: targetInMarketDateEnd || undefined,
      targetInMarketDateStart: targetInMarketDateStart || undefined,
      uhubStatus: uhubStatus || undefined,
      briefType: briefType || undefined,
      workfrontProjectId: workfrontProjectId || undefined,
    },
  })
